// extracted by mini-css-extract-plugin
export default {"pickerAnchor":"pickerAnchor___Ooo3P"};